"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFeatureFlagsVariation = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackFeatureFlagsVariation(featureFlagsVariation) {
    if (Object.keys(featureFlagsVariation).length > 0) {
        (0, pushToDataLayer_1.pushToDataLayer)(featureFlagsVariation);
    }
}
exports.trackFeatureFlagsVariation = trackFeatureFlagsVariation;
//# sourceMappingURL=trackFeatureFlagsVariation.js.map